var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 24,
    viewBox: "0 0 18 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M16.71 2.37H12.41V.77c0-.425-.352-.77-.785-.77H5.872c-.434 0-.785.345-.785.77v1.6H.785c-.433 0-.785.345-.785.77v2.37c0 .425.352.77.785.77H16.71c.434 0 .785-.345.785-.77V3.14c0-.425-.351-.77-.785-.77zm-5.872 0h-4.18v-.83h4.18v.83zM1.121 7.85l.649 15.396c.018.422.362.754.781.754h12.393c.42 0 .764-.332.781-.754l.649-15.396H1.12zM6.384 20.8c0 .434-.35.787-.782.787-.432 0-.783-.353-.783-.787v-9.747c0-.435.35-.787.783-.787.431 0 .782.352.782.787v9.747zm3.146 0c0 .434-.35.787-.782.787-.432 0-.783-.353-.783-.787v-9.747c0-.435.35-.787.783-.787.431 0 .782.352.782.787v9.747zm3.146 0c0 .434-.35.787-.782.787-.432 0-.782-.353-.782-.787v-9.747c0-.435.35-.787.782-.787.431 0 .782.352.782.787v9.747z",
    transform: "translate(-1469 -531) translate(1469 531)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDelete);
export default __webpack_public_path__ + "static/media/ic_delete.409e1564a909fcb19fc8790ecb7c9587.svg";
export { ForwardRef as ReactComponent };